import { mtFetch, type FetchResult } from "./mtFetch";

export interface AdminOverview {
  schema_version: string;
  review_items: {
    by_status: Array<{ status: string; count: number }>;
    open_by_type: Array<{ item_type: string; count: number }>;
  };
  glossary_terms: {
    total_active: number;
    hard_active: number;
    hint_active: number;
    breakdown: Array<{
      status: string | null;
      ru_term_source: string | null;
      source_role: string | null;
      constraint_eligible: string | null;
      morph_safe: string | null;
      count: number;
    }>;
  };
  abbreviations: { by_status: Array<{ status: string; count: number }> };
  term_aliases: {
    by_status: Array<{ status: string; alias_kind: string; count: number }>;
  };
  llm_suggestions: {
    by_status: Array<{ status: string; mode: string; count: number }>;
  };
  translation_feedback?: {
    by_status: Array<{ status: string; count: number }>;
  };
}

export function getAdminOverview(): Promise<FetchResult<AdminOverview>> {
  return mtFetch<AdminOverview>("/admin/overview-stats");
}
import type {
  BulkDecisionRequest,
  BulkDecisionResponse,
  RecordDecisionRequest,
  RecordDecisionResponse,
  ReviewFilterOptions,
  ReviewItemDetail,
  ReviewItemsList,
  ReviewersList,
} from "./types";

export type ListReviewItemsFilters = {
  status?: string;
  item_type?: string;
  domain?: string;
  source_key?: string;
  review_queue?: string;
  q?: string;
  limit?: number;
  offset?: number;
};

export function listReviewItems(
  filters: ListReviewItemsFilters = {},
): Promise<FetchResult<ReviewItemsList>> {
  return mtFetch<ReviewItemsList>("/admin/review-items", {
    query: filters,
  });
}

export function getReviewItem(
  stableKey: string,
): Promise<FetchResult<ReviewItemDetail>> {
  return mtFetch<ReviewItemDetail>(
    `/admin/review-items/${encodeURIComponent(stableKey)}`,
  );
}

export function recordDecision(
  stableKey: string,
  body: RecordDecisionRequest,
): Promise<FetchResult<RecordDecisionResponse>> {
  return mtFetch<RecordDecisionResponse>(
    `/admin/review-items/${encodeURIComponent(stableKey)}/decisions`,
    { method: "POST", body },
  );
}

export function recordBulkDecisions(
  body: BulkDecisionRequest,
): Promise<FetchResult<BulkDecisionResponse>> {
  return mtFetch<BulkDecisionResponse>("/admin/review-decisions/batch", {
    method: "POST",
    body,
  });
}

export function listFilterOptions(): Promise<FetchResult<ReviewFilterOptions>> {
  return mtFetch<ReviewFilterOptions>("/admin/review-filter-options");
}

export function listReviewers(): Promise<FetchResult<ReviewersList>> {
  return mtFetch<ReviewersList>("/admin/reviewers");
}
